if(!customElements.get('featured-videos')) {
  customElements.define(
    'featured-videos',
    class FeaturedVideos extends HTMLElement {
      #sliderEl = undefined;
      #sliderInstance = undefined;
      #sliderPrevEl = undefined;
      #sliderNextEl = undefined;
      #sliderPaginationEl = undefined;

      connectedCallback() {
        this.#sliderEl = this.querySelector('[data-slider]');
        this.#sliderPrevEl = this.querySelector('[data-slider-prev]');
        this.#sliderNextEl = this.querySelector('[data-slider-next]');
        this.#sliderPaginationEl = this.querySelector('[data-slider-pagination]');
        this.mount();
      }

      mount() {
        if(!this.#sliderEl) {
          this.remove();
          return console.error('[Featured Videos] No slider element was found.');
        }
        
        this.#sliderInstance = new Swiper(this.#sliderEl, {
          loop: true,
          slidesPerView: 1.2,
          centeredSlides: true,
          breakpoints: {
            640: {
              slidesPerView: 2.2,
            },
            768: {
              slidesPerView: 3.5,
            },
            1024: {
              slidesPerView: 4.5,
            }
          }
        });
        
        this.#sliderInstance.on("activeIndexChange", (swiper) => this.handleSlideChange(swiper));
      }

      handleSlideChange(swiper) {
        const slides = swiper.slides;

        const prevSlide = slides[swiper.previousIndex];
        const activeSlide = slides[swiper.activeIndex];

        const prevVideoCard = prevSlide?.querySelector('video-card');
        const activeVideoCard = activeSlide?.querySelector('video-card');

        if (prevVideoCard) prevVideoCard.stop();
        if (activeVideoCard) activeVideoCard.play();
      }

      get slider() {
        return this.#sliderInstance;
      }
    }
  )
}